export default __webpack_public_path__ + "static/O0214-2fea3344048f82186af9ac2cbc1522cd.png";